import SelectInput from "@components/formFields/SelectInput/SelectInput";

export default SelectInput;
